<template>
  <div
    class="p-4 block sm:flex items-center justify-between border-b border-gray-200 lg:mt-1.5 dark:border-gray-700"
  >
    <div class="w-full mb-1">
      <div class="sm:flex">
        <div class="flex items-center mr-auto space-x-2">
          <form class="flex items-center">
            <label for="simple-search" class="sr-only">Search</label>
            <div class="relative w-full">
              <div
                class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none"
              >
                <svg
                  aria-hidden="true"
                  class="w-5 h-5 text-gray-500 dark:text-gray-400"
                  fill="currentColor"
                  viewbox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                    clip-rule="evenodd"
                  />
                </svg>
              </div>
              <input
                v-model="searchQuery"
                type="text"
                id="simple-search"
                class="block w-full p-2 pl-10 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                placeholder="Search"
                @keydown.enter.prevent
              />
            </div>
          </form>
          <button
            v-if="searchQuery"
            @click="searchQuery = ''"
            type="button"
            class="text-gray-900 bg-white border border-gray-300 focus:outline-none hover:bg-gray-100 focus:ring-4 focus:ring-gray-100 font-medium rounded-lg px-3 py-2 text-xs h-10 dark:bg-gray-800 dark:text-white dark:border-gray-600 dark:hover:bg-gray-700 dark:hover:border-gray-600 dark:focus:ring-gray-700"
          >
            Clear search
          </button>
        </div>
        <div class="flex items-center ml-auto space-x-2 sm:space-x-3">
          <button
            @click="exportToCSV"
            class="hidden sm:inline-flex items-center justify-center px-3 py-2 text-sm font-medium text-center text-white rounded-lg bg-primary-700 hover:bg-primary-800 focus:ring-4 focus:ring-primary-300 sm:w-auto dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800"
          >
            <Icon class="w-5 h-5 mr-2" icon="ph-export" />
            Export
          </button>
          <button
            id="dropdownSmallButton"
            data-dropdown-toggle="dropdownSmall"
            data-dropdown-placement="left-end"
            type="button"
            class="inline-flex items-center justify-center px-4 py-2 text-sm font-medium text-center text-gray-900 border border-gray-300 rounded-lg hover:bg-gray-100 focus:ring-4 focus:ring-gray-100 dark:text-white dark:border-gray-700 dark:hover:bg-gray-700 dark:focus:ring-gray-800"
          >
            <Icon class="w-5 h-5 mr-2" icon="ph-funnel" />
            Filter
          </button>
          <div
            id="dropdownSmall"
            class="z-10 hidden bg-white divide-y divide-gray-100 rounded-lg shadow-lg w-80 dark:bg-gray-700 dark:divide-gray-600"
          >
            <div
              class="flex p-2 rounded hover:bg-gray-100 dark:hover:bg-gray-600"
            >
              <label class="inline-flex items-center w-full cursor-pointer">
                <input
                  type="checkbox"
                  value=""
                  class="sr-only peer"
                  v-model="filterAllActiveTrainings"
                />
                <div
                  class="relative w-9 h-5 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-600 peer-checked:after:translate-x-full rtl:peer-checked:after:translate-x-[-100%] peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-500 peer-checked:bg-blue-600"
                ></div>
                <span
                  class="ms-3 text-sm font-medium text-gray-900 dark:text-gray-300"
                  >Show active trainings</span
                >
              </label>
            </div>
            <ul
              class="py-2 text-sm text-gray-700 dark:text-gray-200"
              aria-labelledby="dropdownSmallButton"
            >
              <li>
                <div
                  class="flex p-2 pl-3 rounded hover:bg-gray-100 dark:hover:bg-gray-600"
                >
                  <div class="flex items-center h-5">
                    <input
                      id="showCompleted"
                      v-model="filterCompleted"
                      aria-describedby="showCompleted"
                      type="checkbox"
                      class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500"
                    />
                  </div>
                  <div class="ms-2 text-sm">
                    <label
                      for="showCompleted"
                      class="font-medium text-gray-900 dark:text-gray-300"
                    >
                      <div>Show completed trainings</div>
                    </label>
                  </div>
                </div>
              </li>
              <li>
                <div
                  class="flex p-2 pl-3 rounded hover:bg-gray-100 dark:hover:bg-gray-600"
                >
                  <div class="flex items-center h-5">
                    <input
                      id="showAccepted"
                      v-model="filterAccepted"
                      aria-describedby="showAccepted"
                      type="checkbox"
                      class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500"
                    />
                  </div>
                  <div class="ms-2 text-sm">
                    <label
                      for="showAccepted"
                      class="font-medium text-gray-900 dark:text-gray-300"
                    >
                      <div>Show accepted</div>
                    </label>
                  </div>
                </div>
              </li>
              <li>
                <div
                  class="flex p-2 pl-3 rounded hover:bg-gray-100 dark:hover:bg-gray-600"
                >
                  <div class="flex items-center h-5">
                    <input
                      id="showUncompleted"
                      v-model="filterUncompleted"
                      aria-describedby="showUncompleted"
                      type="checkbox"
                      class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500"
                    />
                  </div>
                  <div class="ms-2 text-sm">
                    <label
                      for="showUncompleted"
                      class="font-medium text-gray-900 dark:text-gray-300"
                    >
                      <div>Show uncompleted trainings</div>
                    </label>
                  </div>
                </div>
              </li>
              <li>
                <div
                  class="flex p-2 pl-3 rounded hover:bg-gray-100 dark:hover:bg-gray-600"
                >
                  <div class="flex items-center h-5">
                    <input
                      id="showNotAccepted"
                      v-model="filterNotAccepted"
                      aria-describedby="showNotAccepted"
                      type="checkbox"
                      class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500"
                    />
                  </div>
                  <div class="ms-2 text-sm">
                    <label
                      for="showNotAccepted"
                      class="font-medium text-gray-900 dark:text-gray-300"
                    >
                      <div>Show not accepted</div>
                    </label>
                  </div>
                </div>
              </li>
            </ul>
            <div class="py-2">
              <a
                href="#"
                @click="resetFilters"
                class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:hover:bg-gray-600 dark:text-gray-200 dark:hover:text-white"
                >Clear all filters</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="relative overflow-x-auto shadow">
    <table class="w-full divide-y divide-gray-200 dark:divide-gray-600">
      <thead class="bg-gray-100 dark:bg-gray-700">
        <tr>
          <th
            scope="col"
            class="p-4 text-xs font-medium text-left text-gray-500 uppercase dark:text-gray-400 hover:cursor-pointer group/item"
            @click="sort('fullname')"
          >
            <div class="flex">
              Name
              <span v-if="sortColumn === 'fullname'" class="ml-1">
                <Icon
                  v-if="sortDirection === 'asc'"
                  class="w-3 h-3"
                  icon="ph-caret-down-fill"
                />
                <Icon v-else class="w-3 h-3" icon="ph-caret-up-fill" />
              </span>
            </div>
          </th>
          <th
            v-for="training in displayedTrainings"
            :key="training._id"
            scope="col"
            @click="sort(training._id)"
            class="p-4 text-xs font-medium text-left text-gray-500 uppercase dark:text-gray-400 hover:cursor-pointer group/item"
          >
            <div class="flex">
              {{ training.title }}
              <span v-if="sortColumn === training._id" class="ml-1">
                <Icon
                  v-if="sortDirection === 'asc'"
                  class="w-3 h-3"
                  icon="ph-caret-down-fill"
                />
                <Icon v-else class="w-3 h-3" icon="ph-caret-up-fill" />
              </span>
              <span v-else class="invisible group-hover/item:visible ml-1">
                <Icon class="w-3 h-3 opacity-40" icon="ph-caret-down-fill" />
              </span>
            </div>
          </th>
        </tr>
      </thead>
      <tbody
        class="bg-white divide-y divide-gray-200 dark:bg-gray-800 dark:divide-gray-700"
      >
        <tr v-for="user in sortedUsers" :key="user._id">
          <th
            scope="row"
            class="flex items-center p-4 mr-12 space-x-6 whitespace-nowrap"
          >
            <img
              class="w-10 h-10 rounded-full object-cover"
              :src="getUserImage(user)"
              alt="avatar"
            />
            <div class="text-sm font-normal text-gray-500 dark:text-gray-400">
              <div
                class="text-base font-semibold text-gray-900 dark:text-white"
              >
                {{ user.fullname }}
              </div>
            </div>
          </th>
          <td
            v-for="training in displayedTrainings"
            :key="training._id"
            class="min-w-48 p-4 text-base font-medium text-gray-900 dark:text-white"
          >
            <div class="flex items-center space-x-2 justify-end">
              <dl class="grow" v-if="user.bestPercentage[training._id]">
                <dd class="flex items-center">
                  <div
                    class="w-full bg-gray-200 rounded-full dark:bg-gray-700 mr-2"
                  >
                    <div
                      class="bg-blue-600 text-xs font-medium text-blue-100 text-center p-0.5 leading-none rounded-full"
                      :style="{
                        width: user.bestPercentage[training._id] + '%',
                      }"
                    >
                      {{ user.bestPercentage[training._id] }}%
                    </div>
                  </div>
                  <span
                    v-if="user.isManuallyadded[training._id]"
                    class="inline-flex items-center justify-center w-6 h-6 me-2 text-sm font-semibold text-amber-800 bg-amber-100 rounded-full dark:bg-gray-700 dark:text-blue-400"
                  >
                    <svg
                      class="w-3 h-3"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fill="currentColor"
                        d="m18.774 8.245-.892-.893a1.5 1.5 0 0 1-.437-1.052V5.036a2.484 2.484 0 0 0-2.48-2.48H13.7a1.5 1.5 0 0 1-1.052-.438l-.893-.892a2.484 2.484 0 0 0-3.51 0l-.893.892a1.5 1.5 0 0 1-1.052.437H5.036a2.484 2.484 0 0 0-2.48 2.481V6.3a1.5 1.5 0 0 1-.438 1.052l-.892.893a2.484 2.484 0 0 0 0 3.51l.892.893a1.5 1.5 0 0 1 .437 1.052v1.264a2.484 2.484 0 0 0 2.481 2.481H6.3a1.5 1.5 0 0 1 1.052.437l.893.892a2.484 2.484 0 0 0 3.51 0l.893-.892a1.5 1.5 0 0 1 1.052-.437h1.264a2.484 2.484 0 0 0 2.481-2.48V13.7a1.5 1.5 0 0 1 .437-1.052l.892-.893a2.484 2.484 0 0 0 0-3.51Z"
                      />
                      <path
                        fill="#fff"
                        d="M8 13a1 1 0 0 1-.707-.293l-2-2a1 1 0 1 1 1.414-1.414l1.42 1.42 5.318-3.545a1 1 0 0 1 1.11 1.664l-6 4A1 1 0 0 1 8 13Z"
                      />
                    </svg>
                    <span class="sr-only">Manually added</span>
                  </span>
                </dd>
              </dl>
              <dl class="grow" v-if="user.accepted[training._id]">
                <dd class="flex items-center">
                  <div class="">
                    <span
                      class="flex bg-green-100 text-green-800 text-sm font-medium me-2 px-3 py-1 rounded-full dark:bg-green-900 dark:text-green-300"
                    >
                      <Icon class="w-5 h-5 mr-2" icon="ph-check-circle" />
                      Accepted
                    </span>
                  </div>
                  <span
                    v-if="user.isManuallyadded[training._id]"
                    class="inline-flex items-center justify-center w-6 h-6 me-2 text-sm font-semibold text-amber-800 bg-amber-100 rounded-full dark:bg-gray-700 dark:text-blue-400"
                  >
                    <svg
                      class="w-3 h-3"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fill="currentColor"
                        d="m18.774 8.245-.892-.893a1.5 1.5 0 0 1-.437-1.052V5.036a2.484 2.484 0 0 0-2.48-2.48H13.7a1.5 1.5 0 0 1-1.052-.438l-.893-.892a2.484 2.484 0 0 0-3.51 0l-.893.892a1.5 1.5 0 0 1-1.052.437H5.036a2.484 2.484 0 0 0-2.48 2.481V6.3a1.5 1.5 0 0 1-.438 1.052l-.892.893a2.484 2.484 0 0 0 0 3.51l.892.893a1.5 1.5 0 0 1 .437 1.052v1.264a2.484 2.484 0 0 0 2.481 2.481H6.3a1.5 1.5 0 0 1 1.052.437l.893.892a2.484 2.484 0 0 0 3.51 0l.893-.892a1.5 1.5 0 0 1 1.052-.437h1.264a2.484 2.484 0 0 0 2.481-2.48V13.7a1.5 1.5 0 0 1 .437-1.052l.892-.893a2.484 2.484 0 0 0 0-3.51Z"
                      />
                      <path
                        fill="#fff"
                        d="M8 13a1 1 0 0 1-.707-.293l-2-2a1 1 0 1 1 1.414-1.414l1.42 1.42 5.318-3.545a1 1 0 0 1 1.11 1.664l-6 4A1 1 0 0 1 8 13Z"
                      />
                    </svg>
                    <span class="sr-only">Manually added</span>
                  </span>
                </dd>
              </dl>
              <dl>
                <button
                  type="button"
                  @click="editStats(user, training)"
                  class="text-blue-700 border border-blue-700 hover:border-green-700 hover:bg-green-700 hover:text-white focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm p-2.5 text-center inline-flex items-center me-2 dark:border-blue-500 dark:text-blue-500 dark:hover:text-white dark:focus:ring-blue-800 dark:hover:bg-blue-500"
                >
                  <Icon class="w-5 h-5" icon="ph-pen" />
                </button>
              </dl>
            </div>
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr class="font-semibold text-gray-900 dark:text-white">
          <td class="px-6 py-3">Number of users: {{ sortedUsers.length }}</td>
          <td
            v-for="training in displayedTrainings"
            :key="training._id"
            class="px-6 py-3"
          >
            {{ getCompletedUsersCount(training._id) }} of
            {{ sortedUsers.length }}
          </td>
        </tr>
      </tfoot>
    </table>
  </div>

  <div
    id="edit-stats-modal"
    tabindex="-1"
    aria-hidden="true"
    class="hidden overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-60 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full"
  >
    <div class="relative p-4 w-full max-w-lg max-h-full">
      <div class="relative bg-white rounded-lg shadow dark:bg-gray-700">
        <div
          class="flex items-center justify-between p-4 md:p-5 border-b rounded-t dark:border-gray-600"
        >
          <h3 class="text-lg font-semibold text-gray-900 dark:text-white">
            Edit Stats for {{ editedStats.user.fullname }}
          </h3>
          <button
            @click="toggleEditModal"
            type="button"
            class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white outline-none"
          >
            <svg
              class="w-3 h-3"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 14 14"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
              />
            </svg>
            <span class="sr-only">Close modal</span>
          </button>
        </div>
        <form
          @submit.prevent="sendUsersAnswersToDB(editedStats)"
          class="p-4 md:p-5"
        >
          <div
            class="grid gap-2 mb-4 grid-cols-2 font-medium text-gray-900 dark:text-white"
          >
            <div class="col-span-2">
              You are changing the
              <span v-if="editedStats.training.accept_only">policy</span
              ><span v-else>stats</span> for
            </div>
            <div class="col-span-2 text-lg pb-2">
              {{ editedStats.training.title }}
            </div>
          </div>
          <div class="flex justify-between">
            <button
              type="submit"
              class="text-white inline-flex items-center bg-green-700 hover:bg-green-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
            >
              <Icon class="w-4 h-4 ml-0 mr-2" icon="ph:check" />
              <span v-if="editedStats.training.accept_only">Set accepted</span
              ><span v-else>Set completed</span>
            </button>
            <button
              type="button"
              @click="deleteStats(editedStats)"
              class="text-white inline-flex items-center bg-red-700 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
            >
              <Icon class="w-4 h-4 ml-0 mr-2" icon="ph:minus-circle" />
              <span v-if="editedStats.training.accept_only">Clear accepted</span
              ><span v-else>Clear all stats</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getAllUsers,
  fetchAllStats,
  saveUserResponse,
  saveUserAcceptResponse,
  deleteUserTrainingResponses,
} from "@/api/index.js";
import { initFlowbite, Modal, Tooltip } from "flowbite";
import { Icon } from "@iconify/vue";
import defaultImage from "@/assets/img/default.png";
import { useTrainingsStore } from "@/store/trainings.js";

export default {
  emits: ["scrollToTop"],
  data() {
    return {
      users: [],
      searchQuery: "",
      trainings: [],
      allStats: [],
      sortColumn: "fullname",
      sortDirection: "asc",
      filterAllActiveTrainings: true,
      filterUncompleted: false,
      filterNotAccepted: false,
      filterCompleted: false,
      filterAccepted: false,
      editedStats: {
        user: Object,
        training: Object,
      },
    };
  },
  components: {
    Icon,
  },
  methods: {
    toggleEditModal() {
      this.edit_stats_modal.toggle();
    },
    async getAllUsers() {
      try {
        const users = await getAllUsers();
        this.users = users;
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    },
    async fetchAllTrainings() {
      try {
        this.trainings = await useTrainingsStore().getAll();
      } catch (error) {
        console.error("Error fetching trainings:", error);
      }
    },
    async fetchAllStats() {
      try {
        this.allStats = await fetchAllStats();
      } catch (error) {
        console.log("Error fetching stats;", error);
      }
    },
    async editStats(user, training) {
      this.editedStats.user = user;
      this.editedStats.training = training;
      this.toggleEditModal();
    },
    sort(column) {
      if (this.sortColumn === column) {
        this.sortDirection = this.sortDirection === "asc" ? "desc" : "asc";
      } else {
        this.sortColumn = column;
        this.sortDirection = "asc";
      }
    },
    getCompletedUsersCount(trainingId) {
      if (!trainingId) return 0;
      return this.sortedUsers.filter(
        (user) => user.bestPercentage[trainingId] || user.accepted[trainingId]
      ).length;
    },
    resetFilters() {
      this.filterUncompleted = false;
      this.filterNotAccepted = false;
      this.filterAccepted = false;
      this.filterCompleted = false;
    },
    getUserImage(user) {
      const ad = user.azure_ad;
      if (ad && ad.profile_image !== undefined) {
        try {
          const bufferData = ad.profile_image.data;
          if (!bufferData || !Array.isArray(bufferData)) {
            console.error("Invalid profile image data");
            return;
          }
          const uint8Array = new Uint8Array(bufferData);
          const base64String = btoa(
            String.fromCharCode.apply(null, uint8Array)
          );
          const profileImageUrl = `data:image/jpeg;base64,${base64String}`;
          return profileImageUrl;
        } catch (error) {
          console.error("Error decoding profile image:", error);
        }
      } else {
        return defaultImage;
      }
    },
    async sendUsersAnswersToDB(val) {
      const isAcceptOnly = val.training.accept_only;
      const data = isAcceptOnly
        ? {
            user: val.user._id,
            training_section: val.training._id,
            accepted: true,
            manual: true,
          }
        : {
            user: val.user._id,
            training_section: val.training._id,
            responses: [{ correct: 1 }],
            manual: true,
          };

      try {
        if (isAcceptOnly) {
          await saveUserAcceptResponse(data);
        } else {
          await saveUserResponse(data);
        }
        this.fetchAllStats();
      } catch (error) {
        console.error("Error saving response", error);
      }
    },
    async deleteStats(val) {
      try {
        const userId = val.user._id;
        const trainingSectionId = val.training._id;

        const result = await deleteUserTrainingResponses(
          userId,
          trainingSectionId
        );
        this.fetchAllStats();
        console.log("Deleted:", result);
      } catch (error) {
        console.error("Error deleting stats", error);
      }
    },
    exportToCSV() {
      const headers = ["Name", ...this.displayedTrainings.map((t) => t.title)];
      const rows = this.sortedUsers.map((user) => {
        const row = [user.fullname];
        this.displayedTrainings.forEach((training) => {
          const percentage = user.bestPercentage[training._id];
          const accepted = user.accepted[training._id] ? "Accepted" : "";
          row.push(
            percentage !== undefined ? `${percentage}% ${accepted}` : "N/A"
          );
        });
        return row;
      });

      let csvContent = "data:text/csv;charset=utf-8,";
      csvContent += headers.join(",") + "\n";
      csvContent += rows.map((row) => row.join(",")).join("\n");

      const encodedUri = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", "export-stenkoll.csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
  },
  mounted() {
    initFlowbite();
    const editModal = document.getElementById("edit-stats-modal");

    const options = {
      placement: "bottom-right",
      backdrop: "dynamic",
      backdropClasses: "bg-gray-900/50 dark:bg-gray-900/80 fixed inset-0 z-50",
      closable: true,
      onHide: () => {},
      onShow: () => {},
      onToggle: () => {},
    };

    const editInstanceOptions = {
      id: "edit-stats-modal",
      override: true,
    };

    this.getAllUsers();
    this.fetchAllTrainings();
    this.fetchAllStats();

    this.edit_stats_modal = new Modal(editModal, options, editInstanceOptions);
  },
  computed: {
    displayedTrainings() {
      return this.filterAllActiveTrainings
        ? useTrainingsStore().allActiveTrainings
        : this.trainings;
    },
    sortedUsers() {
      return this.filteredUsers.sort((a, b) => {
        if (this.sortColumn === "fullname") {
          return this.sortDirection === "asc"
            ? a.fullname.localeCompare(b.fullname)
            : b.fullname.localeCompare(a.fullname);
        } else {
          const percentageA = a.bestPercentage[this.sortColumn] || 0;
          const percentageB = b.bestPercentage[this.sortColumn] || 0;
          // Check if the training has acceptance criteria
          const hasAcceptance =
            a.accepted[this.sortColumn] || b.accepted[this.sortColumn];
          if (hasAcceptance) {
            // If acceptance status is different, sort based on acceptance
            if (a.accepted[this.sortColumn] !== b.accepted[this.sortColumn]) {
              return this.sortDirection === "asc"
                ? a.accepted[this.sortColumn]
                  ? -1
                  : 1
                : a.accepted[this.sortColumn]
                ? 1
                : -1;
            }
          }
          // If both users have the same acceptance status, sort based on percentage
          return this.sortDirection === "asc"
            ? percentageB - percentageA
            : percentageA - percentageB;
        }
      });
    },
    filteredUsers() {
      const query = this.searchQuery.toLowerCase();
      const visibleTrainings = this.displayedTrainings.map((t) => t._id);

      return this.users
        .map((user) => {
          const stats = this.allStats.filter((stat) => stat.user === user._id);
          const userBestPercentages = {};
          const acceptedResponse = {};
          const manuallyAddedMap = {};

          this.trainings.forEach((training) => {
            const trainingStats = stats.filter(
              (stat) => String(stat.training_section) === String(training._id)
            );

            let highestScore = null;

            trainingStats.forEach((attempt) => {
              if (attempt.responses && attempt.responses.length > 0) {
                let totalScore = 0;
                let totalQuestions = attempt.responses.length;

                attempt.responses.forEach((response) => {
                  totalScore += response.correct;
                });

                const percent = (totalScore / totalQuestions) * 100;

                if (highestScore === null || percent > highestScore) {
                  highestScore = percent;
                }
              }
            });

            if (highestScore === null && trainingStats.length > 0) {
              highestScore = 0;
            }

            if (highestScore !== null) {
              userBestPercentages[training._id] = highestScore;
            }

            if (trainingStats.some((attempt) => attempt.accepted === true)) {
              acceptedResponse[training._id] = true;
            }

            manuallyAddedMap[training._id] = trainingStats.some(
              (attempt) => attempt.manual === true
            );
          });

          // Per training stats
          const hasCompletedAnyVisible = visibleTrainings.some(
            (id) => userBestPercentages[id] > 0
          );
          const hasAcceptedAnyVisible = visibleTrainings.some(
            (id) => acceptedResponse[id]
          );
          const hasUncompletedVisible = visibleTrainings.every(
            (id) => !userBestPercentages[id] || userBestPercentages[id] === 0
          );
          const hasNotAcceptedVisible = visibleTrainings.every(
            (id) => !acceptedResponse[id]
          );

          return {
            ...user,
            bestPercentage: userBestPercentages,
            accepted: acceptedResponse,
            hasCompletedAnyVisible,
            hasAcceptedAnyVisible,
            hasUncompletedVisible,
            hasNotAcceptedVisible,
            isManuallyadded: manuallyAddedMap,
          };
        })
        .filter((user) => {
          return (
            (user.fullname.toLowerCase().includes(query) ||
              user.email.toLowerCase().includes(query)) &&
            (!this.filterCompleted || user.hasCompletedAnyVisible) &&
            (!this.filterAccepted || user.hasAcceptedAnyVisible) &&
            (!this.filterUncompleted || user.hasUncompletedVisible) &&
            (!this.filterNotAccepted || user.hasNotAcceptedVisible)
          );
        });
    },
  },
};
</script>
